import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import "./styles/global.css";
import request from "./utils/request";

Vue.use(ElementUI);
Vue.config.productionTip = false;

// Inject API request instance into Vue prototype
Vue.prototype.$api = request;

function redirectMisroutedH5Path() {
  if (typeof window === "undefined" || !window.location) return false;

  const { pathname, search, origin } = window.location;
  const normalizedPath = String(pathname || "").trim();
  if (!normalizedPath) return false;

  const matched = normalizedPath.match(/^\/h5\/([^/?#]+)(?:\/([^?#]*))?$/i);
  if (!matched) return false;

  const routeType = String(matched[1] || "").trim();
  const routeValue = String(matched[2] || "").trim();
  if (!routeType || /^index\.html$/i.test(routeType)) return false;

  const target = new URL("/h5/index.html", origin || window.location.href);
  if (routeValue) {
    target.searchParams.set("type", routeType);
    target.searchParams.set("value", routeValue);
  } else if (search) {
    target.search = search;
  } else {
    target.searchParams.set("type", routeType);
    target.searchParams.set("value", "all");
  }

  window.location.replace(target.toString());
  return true;
}

if (!redirectMisroutedH5Path()) {
  // Prevent dev overlay for uncaught axios network errors when backend is not running.
  window.addEventListener("unhandledrejection", (event) => {
    const msg = event?.reason?.message || "";
    if (msg.includes("Network Error")) {
      event.preventDefault();
    }
  });

  new Vue({
    router,
    render: (h) => h(App)
  }).$mount("#app");
}
